import { h, render, Component } from 'preact';
import { checkRequiredInvalid, checkEmail, checkPhoneInvalid } from '../utils/utils';
import TxrInput from './txr-input';
import { appConfig } from '../app.config';
import qs from 'qs';
import axios from 'axios';

class TxrWebinarGatedContentForm extends Component {
    state = {
        isSubmitted: false,
        isValid: false,
        messageSent: false,
        messageError: false,
        isLoading: false,
        errors: {
            required: 'Required field',
            email: 'Please enter a valid e-mail',
            phone: 'Phone numbers must be 10 or 11 digits.'
        },
        firstNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        lastNameModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        emailModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkEmail(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        companyModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
        phoneModel: {
            value: '',
            invalid: false,
            errors: {},
            change: (model) => {
                const hasError = checkRequiredInvalid(model, this.state.isSubmitted) || checkPhoneInvalid(model, this.state.isSubmitted);
                model.invalid = hasError && this.state.isSubmitted;
                this.forceUpdate();
            }
        },
    }
    sent = () => {
        this.state.isSubmitted = true;
        this.setState({isSubmitted: true});

        this.state.firstNameModel.change(this.state.firstNameModel);
        this.state.lastNameModel.change(this.state.lastNameModel);
        this.state.emailModel.change(this.state.emailModel);
        this.state.companyModel.change(this.state.companyModel);
        this.state.phoneModel.change(this.state.phoneModel);

        if (this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.emailModel.invalid || this.state.companyModel.invalid || this.state.phoneModel.invalid) {
            return;
        }
        this.setState({isLoading: true, messageSent: false});
        const data =
        {
            firstName: this.state.firstNameModel.value,
            lastName: this.state.lastNameModel.value,
            company: this.state.companyModel.value,
            email: this.state.emailModel.value,
            phone: this.state.phoneModel.value,
            meetingId: '83967490359' // hardcoded
        };

        /*
        const d = {};
        
        for (var p in data) {
            if (!data[p]) {
                continue;
            }
            d[encodeURIComponent(p)] = encodeURIComponent(data[p]);
        }*/
       
        const url = `${appConfig.url}/webservices/webinars/signup`;
        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            data: JSON.stringify(data),
            url,
        };
        axios(options)
        .then(() => {
            this.setState({isLoading: false, messageSent: true, messageError: false });
        })
        .catch((err) => {
            console.error(err);
             this.setState({isLoading: false, messageSent: false, messageError: true });
        });
    }
    onSubmit = e => {
        return false;
      }
    render() {
        return (
            <div class="txr-webinar-gated-content-form">
            {!this.state.messageSent && !this.state.messageError &&
                <form onsubmit={this.onSubmit} class="gated-content-form">
                     <div class="txr-form__item">
                         <TxrInput model={this.state.firstNameModel} type="text" name="firstName" label="First Name" errors={this.state.errors}> </TxrInput>
                     </div>
                     <div class="txr-form__item">
                         <TxrInput model={this.state.lastNameModel} type="text" name="lastName" label="Last Name" errors={this.state.errors}> </TxrInput>
                     </div>

                     <div class="txr-form__item">
                        <TxrInput model={this.state.emailModel} type="email" name="email" label="Your Email" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__item">
                        <TxrInput model={this.state.companyModel} type="text" name="company" label="Company" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__item">
                        <TxrInput model={this.state.phoneModel} type="text" name="phone" label="Phone Number" errors={this.state.errors}></TxrInput>
                     </div>
                     <div class="txr-form__button">
                            <button class="txr-button txr-primary-button" disabled={(this.state.firstNameModel.invalid || this.state.lastNameModel.invalid || this.state.emailModel.invalid  || this.state.companyModel.invalid || this.state.phoneModel.invalid) && this.state.isSubmitted} type="button" onClick={() => this.sent()}>
                                <span class="txr-button__content"> REGISTER NOW
                                    {!this.state.isLoading && <i class="txr-button__angle-icon fal fa-angle-right"></i>}
                                    {this.state.isLoading && <i class="fas fa-circle-notch fa-spin txr-ml5"></i>}
                                </span>
                            </button>
                      </div>

                </form>
            }
            {this.state.messageSent &&
            <div class="gated-content-complete">
                  <div class="complete__title">  
                    You’re in!<br/>See you on March 14th.
                  </div>
                  {/*<img class="complete__icon" src="/images/webinar/icon-date.png"></img>*/}
                  <div class="complete__text">  
                  Check your email for confirmation and a calendar invite.
                  </div>

                </div>
            }
             {this.state.messageError &&
                    <div class="gated-content-error">
                        An error occurred during submit form
                    </div>
                }
            </div>
        )
    }
}

export default TxrWebinarGatedContentForm;